/**
 * Internal dependencies
 */
import { bold } from './bold';
import { code } from './code';
import { image } from './image';
import { italic } from './italic';
import { link } from './link';
import { strikethrough } from './strikethrough';
import { underline } from './underline';
export default [bold, code, image, italic, link, strikethrough, underline];
//# sourceMappingURL=default-formats.js.map